import { useMemo } from 'react';
import { useNavigate, useQueryState, useI18n, useMutation } from '@ywwwtseng/react-kit';
import { SelectNetwork } from '@/components/common/SelectNetwork';
import { type FormElement, Form, validator, useForm } from '@/lib/react-form';

export default function AddTokenScreen() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const networks = useQueryState<string[]>('networks');
  const { mutate, isLoading } = useMutation('token:add');
  const form = useForm({
    values: {
      default: {
        network: null,
        token_address: '',
      },
    },
  });

  const elements = useMemo<{ row: FormElement[] }[]>(() => {
    const values = form.values;

    return [
      {
        row: [
          {
            ui: 'custom',
            name: 'network',
            validate: validator.required({
              message: t('validation.required', {
                name: t('common.network'),
              }),
            }),
            render: ({ setValue }) => (
              <SelectNetwork
                network={values.network as string | null}
                onNetworkSelected={(network) => {
                  setValue('network', network);
                }}
              />
            ),
          },
        ],
      },
      {
        row: [
          {
            ui: 'text',
            label: t('add_token.token_address'),
            name: 'token_address',
            validate: validator.required({
              message: t('validation.required', {
                name: t('add_token.token_address'),
              }),
            }),
            props: {
              placeholder: t('add_token.token_address_placeholder'),
              disabled: !values.network,
            },
          },
        ],
      },
    ];
  }, [form.values, networks]);

  return (
    <div className="flex flex-col justify-start w-full h-full gap-2 py-3 px-5">
      <Form
        name="deposit"
        isLoading={isLoading}
        {...form}
        elements={elements}
        submit={{
          label: t('common.add'),
        }}
        onSubmit={(values) => {
          void mutate({
            network: values.network as string,
            token_address: values.token_address as string,
          }).then((result) => {
            if (result.ok) {
              navigate(-1);
            }
          });
        }}
      />
    </div>
  );
}
